module.exports = __webpack_public_path__ + "img/stella_roux_intro.da888a34.png";